import { createContext } from 'react';

export const RemovableElementContext = createContext<{ onRemove: (id: string) => void }>({ onRemove: () => undefined });
